import { T } from "../tokens";

/** Minimal, theme-aware loading indicator shared by the auth-hydration gate
 *  (App.tsx) and the resume-status gate (ResumeGate.tsx) — both need to hold
 *  a neutral state while async status resolves, instead of flashing the
 *  wrong screen (login, dashboard, onboarding) before the real answer is in. */
export function LoadingState({ fullPage = false, label = "Loading…" }: {
  fullPage?: boolean;
  label?: string;
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        minHeight: fullPage ? "100dvh" : "40vh",
        background: fullPage ? T.bg : "transparent",
      }}
    >
      <span style={{ fontFamily: T.body, fontSize: "13px", color: T.t2 }}>{label}</span>
    </div>
  );
}
